const BG_COLOR_LIGHT = 0xffffff;
const BG_COLOR_DARK = 0x1c1b23;

export function isDarkModeEnabled() {
  const params = new URLSearchParams(window.location.search);
  const darkParam =
    (params.get("Dark") || params.get("dark") || "false")
      .trim()
      .toLowerCase() === "true";
  return darkParam;
}

export function getBackgroundColor() {
  return isDarkModeEnabled() ? BG_COLOR_DARK : BG_COLOR_LIGHT;
}

export function getPurpose() {
  const params = new URLSearchParams(window.location.search);
  return (params.get("purpose") || "not set").trim();
}

export function getHvToken() {
  const params = new URLSearchParams(window.location.search);
  return (params.get("token") || "").trim();
}

export function maybeSubtract(hi: any, lo: any): number | null {
  if (typeof hi !== "number" || typeof lo !== "number") {
    return null;
  }
  return hi - lo;
}

export function maybeMax(a: any, b: any): number | null {
  const values = [a, b].filter((x) => typeof x === "number");
  return values ? Math.max(...values) : null;
}

export function maybeMin(a: any, b: any): number | null {
  const values = [a, b].filter((x) => typeof x === "number");
  return values ? Math.min(...values) : null;
}
